<template>
    <div class="fluid">
        <h1 class="app-title">Gerar Requisição - Comunicação de Transferência de Honorários Realizada</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard
                            ref="wizard"
                            nextButtonText="Próximo"
                            backButtonText="Anterior"
                            finishButtonText="Concluir"
                            title
                            subtitle
                            color="#0A9C70" >
                        <wizard-step
                                slot-scope="props"
                                slot="step"
                                :tab="props.tab"
                                :index="props.index"
                        ></wizard-step>
                        <tab-content
                            icon="fas fa-id-card"
                            class="mx-auto"
                            title="Indicar o Processo">
                            <p class="mb-2">Informe o número do processo:</p>
                            <b-row>
                                <b-col sm="12" md="4">
                                    <b-form-group
                                        label="Número CNJ:"
                                        label-for="cnj"
                                        description="Somente os números"
                                        class="text-label">

                                        <b-form-input
                                            ref="cnj"
                                            type="text"
                                            id="num-documento"
                                            v-model="filtros.cnj"
                                            v-mask="['#######-##.####.#.##.####']"
                                            @change="completarCnj();"
                                            :class="'cnj ' + (!validations.cnj.valid ? 'is-invalid' : '')"
                                        ></b-form-input>
                                        <span v-if="!validations.cnj.valid" class="invalid-message">Número CNJ inválido!</span>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </tab-content>
                        <tab-content
                            icon="fas fa-clipboard-check"
                            class="mx-auto"
                            title="Histórico de Requisições">
                            <TabelaPesquisas
                                :resultado="items"
                                :configTable="configTable"
                                :filtroComponente="filtro"
                                :filtros="filtros"
                                :loading="$refs.loading"
                                :cnj="filtros.cnj"
                                @prevTab="prevTab"
                                @nextStep="nextStep"
                                @openFilterPopup="openFilterPopup"
                                @consultar="consultar"
                                @consultarComScroll="(update) => { updated = update; consultarComScroll() }"
                                @limparFiltros="limparFiltros"
                                @obterComunicacaoTransferencia="obterComunicacaoTransferencia"
                                @alterarTitularReceita="alterarTitularReceita"/>
                        </tab-content>
                        <tab-content
                                icon="fas fa-file-invoice-dollar"
                                class="mx-auto"
                                title="Indique os dados da Transferência">
                            <DadosComunicacaoTransferencia ref="dadosComunicacaoTransferencia"
                                                           :comunicacao-transferencia="comunicacaoTransferencia"
                                                           :validations="validations"
                                                           @alterarValidadeValor="alterarValidadeValor"/>
                        </tab-content>
                        <tab-content
                                icon="fas fa-clipboard-check"
                                class="mx-auto"
                                title="Comunicação Gerada" >
                            <ConclusaoComunicacaoTransferencia :codigo-receita="codigoReceita"
                                                               :comunicacao-transferencia="comunicacaoTransferencia"/>
                        </tab-content>

                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-between">
                                <b-col sm="12" md="2">
                                    <b-button
                                            v-if="props.activeTabIndex > 0 && !props.isLastStep"
                                            @click="props.prevTab()"
                                            variant="secondary" >
                                        <i class="fa fa-arrow-left"></i> Anterior
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="4" class="text-right">
                                    <b-button v-if="props.activeTabIndex == 0"
                                              @click="salvar" :disabled="load || !validations.valor.valid"
                                              variant="warning">
                                        Concluir Geração da Comunicação
                                        <i class="fa fa-file-pdf" v-if="!load"></i>
                                        <b-spinner small v-if="load"></b-spinner>
                                    </b-button>
                                </b-col>
                            </div>
                        </template>
                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-between">
                                <b-col sm="12" md="2">
                                    <b-button
                                        v-if="props.activeTabIndex > 1 && !props.isLastStep"
                                        @click="prevTab"
                                        variant="secondary" >
                                        <i class="fa fa-arrow-left"></i> Anterior
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right" v-if="props.activeTabIndex == 0">
                                    <b-button
                                        id="btnProxima"
                                        @click="nextStep"
                                        :disabled="!cnjValido || (props.activeTabIndex == 2 && !validations.valor.valid)"
                                        variant="primary">
                                        Próxima
                                        <i class="fa fa-arrow-right"></i>
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right" v-if="props.activeTabIndex == 3">
                                    <b-button class="finish-button" variant="success" @click="sair">
                                        Concluir
                                        <i class="fas fa-flag-checkered"></i>
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="6" class="text-right" v-if="props.activeTabIndex == 2">
                                    <b-button variant="secondary" @click="sair" class="mr-2">
                                        <i class="fas fa-sign-out-alt"></i>
                                        Sair Sem Gerar Requisição
                                    </b-button>
                                    <b-button variant="warning"
                                              @click="salvar" :disabled="load || !validations.valor.valid">
                                        <i class="fa fa-file-pdf"></i>
                                        Confirmar Geração da Requisição
                                    </b-button>
                                </b-col>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
                ref="modal-avancar-ef"
                id="modal-avancar-ef"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Número CNJ de Execução Fiscal D.A. SEFA"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>O número CNJ informado consta na base do PROAJU como Execução Fiscal de D.A. inscrita pela SEFA!</p>
                    <p>Para gerar requisição de honorários provenientes de executivo fiscal de D.A. inscrita pela SEFA, utilize o fluxo <i>2) Honorários de Execução Fiscal D.A. SEFA</i>.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-avancar-ef')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-confirmar-data"
                id="modal-confirmar-data"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Verificar Data de Ajuizamento"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>ATENÇÃO! VERIFICAR A DATA DE AJUIZAMENTO!</p>
                    <p>Pelo ano do processo informado, é possível que os honorários sucumbenciais sejam <b>devidos à Caixa Especial de Sucumbência – CES</b> e não ao FEPGE (arts. 150 e 151 do Manual de Procedimentos da PGE). Sendo esta a hipótese (honorários devidos à CES), clique em "Voltar".</p>
                    <p>De outro modo, tratando-se de honorários efetivamente devidos ao FEPGE, clique em "Confirmar a Geração".</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-confirmar-data')"> Voltar</b-button>
                <b-button variant="warning" @click="confirmarSalvar"> <i class="fa fa-file-pdf"></i> Confirmar a Geração</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-confirmar-dupla"
                id="modal-confirmar-dupla"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Atenção!"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>ATENÇÃO! VERIFICAR O TIPO DA AÇÃO E A DATA DE AJUIZAMENTO!</p>
                    <p>O número CNJ informado consta na base do PROAJU, pelo que se deduz tratar-se de processo de <b>execução fiscal</b>! Para gerar comunicação de transferência de honorários provenientes de executivo fiscal, utilize o fluxo <i>2) Honorários de Execução Fiscal - Base de Cálculo D.A. SEFA (para as execuções fiscais de dívidas ativas expedidas pela SEFA)</i> ou <i>3) Honorários de Execução Fiscal - base de Cálculo D.A. Não SEFA</i> (para as execuções fiscais de dívidas ativas que não tenham sido expedidas pela SEFA).</p>

                    <p>Além disso, pelo ano do processo informado, é possível que os honorários sucumbenciais sejam <b>devidos à Caixa Especial de Sucumbência – CES</b> e não ao FEPGE (arts. 150 e 151 do Manual de Procedimentos da PGE).</p>
                    <p>Assim, tratando-se de honorários decorrentes de ação judicial que não seja execução fiscal e efetivamente devidos ao FEPGE (e não à CES), clique em "Confirmar a Geração". Do contrário, clique em "Voltar".</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-confirmar-dupla')"> Voltar</b-button>
                <b-button variant="warning" @click="confirmarSalvar"> <i class="fa fa-file-pdf"></i> Confirmar a Geração</b-button>
            </template>
        </b-modal>
        <CompLoading ref="loading"/>
        <CompFiltroGrid
            ref="compFiltro"
            :filtro="filtro"
            @filtrarResultados="filtrarResultados"
            @ordenarResultados="ordenarResultados"/>
        <b-modal
            ref="modal-cnj-vazio"
            id="modal-cnj-vazio"
            size="xl"
            :content-class="'shadow ' + getTheme"
            :title="'Número do CNJ vazio!'"
            header-bg-variant="success"
            header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>Número do CNJ precisa ser preenchido.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-cnj-vazio');focusCnj();"> OK</b-button>
            </template>
        </b-modal>
        <b-modal
            ref="modal-cnj-invalido"
            id="modal-cnj-invalido"
            size="xl"
            :content-class="'shadow ' + getTheme"
            :title="'Número do CNJ inválido!'"
            header-bg-variant="success"
            header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>Número do CNJ informado é inválido.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-cnj-invalido');focusCnj();"> OK</b-button>
            </template>
        </b-modal>
        <b-modal
            ref="modal-confirmar-data-fepge"
            id="modal-confirmar-data-fepge"
            size="xl"
            :content-class="'shadow ' + getTheme"
            title="ATENÇÃO! VERIFICAR A DATA DE AJUIZAMENTO"
            header-bg-variant="info"
            header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>O ano do processo envolvido no cálculo desta Requisição é 2016 ou posterior, sendo possível que os honorários sucumbenciais relativos a tal processo sejam devidos à Caixa Especial de Sucumbência – CES e não ao FEPGE (conforme Manual de Procedimentos da PGE).</p>
                    <p>Clique em "Continuar" somente se os honorários do processo envolvido no cálculo objeto desta Requisição forem devidos ao FEPGE. Caso os honorários sejam devidos à CES, clique em "Voltar" e selecione a opção "2) CES - Caixa Especial de Sucumbência”.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-confirmar-data-fepge')"> Voltar</b-button>
                <b-button variant="primary" @click="forcarSegundaAba()"> Continuar</b-button>
            </template>
        </b-modal>
        <b-modal
            ref="modal-confirmar-data-ces"
            id="modal-confirmar-data-ces"
            size="xl"
            :content-class="'shadow ' + getTheme"
            title="ATENÇÃO! VERIFICAR A DATA DE AJUIZAMENTO"
            header-bg-variant="info"
            header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>O ano do processo envolvido no cálculo desta Requisição é 2016 ou anterior, sendo possível que os honorários sucumbenciais relativos a tal processo sejam devidos ao FEPGE e não à Caixa Especial de Sucumbência – CES (conforme Manual de Procedimentos da PGE).</p>
                    <p>Clique em "Continuar" somente se os honorários do processo envolvido no cálculo objeto desta Requisição forem devidos à Caixa Especial de Sucumbência. Caso os honorários sejam devidos ao FEPGE, clique em "Voltar" e selecione a opção “1) FEPGE - Fundo Especial da PGE”.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-confirmar-data-ces')"> Voltar</b-button>
                <b-button variant="primary" @click="forcarSegundaAba()"> Continuar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';
    import CompLoading from "../shared/components/CompLoading";
    import formatarMixins from '../../mixins/formatarMixins';

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import DadosComunicacaoTransferencia from "./components/DadosComunicacaoTransferencia";
    import ConclusaoComunicacaoTransferencia from "./components/ConclusaoComunicacaoTransferencia";
    import TabelaPesquisas from "./components/TabelaPesquisas";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";

    export default {
        mixins: [ formatarMixins ],
        components: {
            CompFiltroGrid,
            TabelaPesquisas,
            DadosComunicacaoTransferencia,
            ConclusaoComunicacaoTransferencia,
            FormWizard,
            TabContent,
            WizardStep,
            CompLoading,
        },
        data() {
            return {
                updated: false, 
                urlApi: null,
                token: null,
                cnjValido: true,
                codigoReceita: null,
                currentScroll: null,
                comunicacaoTransferencia: {
                    codComunicacaoTransferencia: null,
                    codDevedor: null,
                    cpfCnpjDevedor: null,
                    nomeDevedor: null,
                    codSetor: null,
                    valor: null,
                    dataTransferencia: null,
                    cnj: null,
                    observacoes: null,
                    titularReceita: null,
                    arquivos: []
                },
                load: false,
                validations: {
                    cnj: { valid: true },
                    cpfCnpjDevedor: { valid: true },
                    cpf: { valid: true },
                    cnpj: { valid: true },
                    nomeDevedor: { valid: true },
                    setor: { valid: true },
                    data: { valid: true, pastDate: true },
                    observacoes: { valid: true },
                    valor: { valid: true, mensagem: '' }
                },
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'requisicao.numeroRequisicao',
                    sortOrder: 'desc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    campoTexto: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    numeroRequisicao: null,
                    cnj: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    tipoPagamento: null,
                    formaPagamento: null,
                    filtrarValor: null,
                    valor: null,
                    situacao: null,
                    titularReceita: 0
                },
                emailCes: null
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            nextStep() {
                if(this.$refs.wizard.activeTabIndex == 0) {
                    this.avancaPrimeiraAba();
                } else if(this.$refs.wizard.activeTabIndex == 1) {
                    if(this.filtros.titularReceita == 0 && parseInt(this.filtros.cnj.substring(11, 15)) >= 2016) {
                        this.$refs['modal-confirmar-data-fepge'].show();
                    } else if(this.filtros.titularReceita == 1 && parseInt(this.filtros.cnj.substring(11, 15)) < 2016) {
                        this.$refs['modal-confirmar-data-ces'].show();
                    } else {
                        this.forcarSegundaAba();
                    }
                }
                this.atribuirStickyTopo(false);
                window.scrollTo(0,0);
            },

            forcarSegundaAba() {
                this.$refs['modal-confirmar-data-fepge'].hide();
                this.$refs['modal-confirmar-data-ces'].hide();

                this.comunicacaoTransferencia.titularReceita = this.filtros.titularReceita;
                this.comunicacaoTransferencia.enviarDocumentacao = true;
                this.comunicacaoTransferencia.email = this.emailCes;

                this.$refs.wizard.nextTab();
                setTimeout(()=>{
                    this.$refs.dadosComunicacaoTransferencia.$forceUpdate();
                }, 100);
            },

            atribuirStickyTopo(force) {
                if(force || this.$refs.wizard.activeTabIndex >= 2) {
                    let anchor = document.querySelector('.wizard-navigation');
                    let divTopo = document.createElement('div');
                    divTopo.id = "div-topo";
                    divTopo.classList.add("topo-sticky");
                    divTopo.classList.add("background-scroller");
                    anchor.insertAdjacentElement('afterbegin', divTopo);

                    let barraWizard = document.getElementsByClassName('wizard-progress-with-circle')[0];
                    let progressoWizard = document.getElementsByClassName('wizard-nav wizard-nav-pills')[0];
                    divTopo.appendChild(barraWizard);
                    divTopo.appendChild(progressoWizard);
                } else {
                    var element = document.getElementById("div-topo");
                    if(element != null) {
                        element.classList.remove("topo-sticky");
                    }
                }
            },

            prevTab() {
                this.$store.commit("setMessages", {});

                if(this.$refs.wizard.activeTabIndex == 2) {
                    this.consultar();
                }
                this.$refs.wizard.prevTab();
                this.atribuirStickyTopo(false);
            },

            completarCnj() {
                if (!this.verificarValorVazio(this.filtros.cnj) && this.onlyNumber(this.filtros.cnj).length < 20) {
                    this.filtros.cnj = this.mascaraCnj(this.onlyNumber(this.filtros.cnj).padStart(20, '0'));
                }
            },

            avancaPrimeiraAba() {
                this.$store.commit("setMessages", {});

                this.completarCnj();

                this.validations.cnj.valid = true;
                if(this.filtros.cnj == null || this.filtros.cnj.trim() == "") {
                    this.validations.cnj.valid = false;
                    return;
                }

                if(this.filtros.cnj.length < 25 || !this.validaCnj(this.filtros.cnj)) {
                    this.validations.cnj.valid = false;
                    return;
                }

                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/verificarExistenciaProcesso/` + this.filtros.cnj, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data) {
                        this.cnjValido = false;
                        this.$refs['modal-avancar-ef'].show();
                    } else {
                        this.cnjValido = true;
                        this.confirmarAvancarPrimeiraAba();
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            confirmarAvancarPrimeiraAba() {
                this.$refs['modal-avancar-ef'].hide();

                this.$refs.wizard.nextTab();

                this.consultar();
            },

            async consultarComScroll() {
                this.currentScroll = document.documentElement.scrollTop;
                if (this.updated) {
                    this.consultar();
                }
            },

            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }

                    if(this.currentScroll != null) {
                        setTimeout(()=>{
                            document.documentElement.scrollTop = this.currentScroll;
                            this.currentScroll = null;
                        }, 100);
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;
                    if(this.filtro.campoFiltro == 'Requisição') {
                        this.filtro.campoMascara = this.filtros.numeroRequisicao;
                    } else if(this.filtro.campoFiltro == 'Devedor') {
                        this.filtro.filtrarEm = this.filtros.filtrarContribuinte;
                        this.filtro.campoTexto = this.filtros.contribuinte;
                    } else if(this.filtro.campoFiltro == 'Data de Geração') {
                        this.filtro.filtrarEm = this.filtros.filtrarDataEmissao;
                        this.filtro.campoData = this.filtros.dataEmissao;
                    } else if(this.filtro.campoFiltro == 'Forma de Pagamento') {
                        this.filtro.campoCheckbox = this.filtros.formaPagamento;
                    } else if(this.filtro.campoFiltro == 'Tipo de Pagamento') {
                        this.filtro.campoCheckbox = this.filtros.tipoPagamento;
                    } else if(this.filtro.campoFiltro == 'Valor Pago (R$)') {
                        this.filtro.filtrarEm = this.filtros.filtrarValor;
                        this.filtro.campoTexto = this.filtros.valor;
                    } else if(this.filtro.campoFiltro == 'Situação da Requisição') {
                        this.filtro.campoCheckbox = this.filtros.situacao;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoCheckbox = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                    this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
                }

                if(this.filtro.campoFiltro == 'Requisição') {
                    this.filtros.numeroRequisicao = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    this.filtros.filtrarContribuinte = this.filtro.filtrarEm;
                    this.filtros.contribuinte = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Data de Geração') {
                    this.filtros.filtrarDataEmissao = this.filtro.filtrarEm;
                    this.filtros.dataEmissao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Forma de Pagamento') {
                    this.filtros.formaPagamento = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Tipo de Pagamento') {
                    this.filtros.tipoPagamento = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Valor Pago (R$)') {
                    this.filtros.filtrarValor = this.filtro.filtrarEm;
                    this.filtros.valor = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Situação da Requisição') {
                    this.filtros.situacao = this.filtro.campoCheckbox;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Requisição') {
                    this.configTable.sortField = 'requisicao.numerorequisicao';
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    this.configTable.sortField = 'requisicao.nomecontribuinte';
                } else if(this.filtro.campoFiltro == 'Data de Geração') {
                    this.configTable.sortField = 'requisicao.dataemissao';
                } else if(this.filtro.campoFiltro == 'Forma de Pagamento') {
                    this.configTable.sortField = 'requisicao.formapagamento';
                } else if(this.filtro.campoFiltro == 'Tipo de Pagamento') {
                    this.configTable.sortField = 'requisicao.tipopagamento';
                } else if(this.filtro.campoFiltro == 'Valor Pago (R$)') {
                    this.configTable.sortField = 'requisicao.valorpago';
                } else if(this.filtro.campoFiltro == 'Situação da Requisição') {
                    this.configTable.sortField = 'requisicao.situacao';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },

            limparFiltros() {
                this.filtros = {
                    numeroRequisicao: null,
                    cnj: this.filtros.cnj,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    tipoPagamento: null,
                    formaPagamento: null,
                    filtrarValor: null,
                    valor: null,
                    situacao: null,
                    titularReceita: 0
                };

                this.consultar();
            },

            async salvar() {
                this.$store.commit("setMessages", {});

                if(!this.verificarObrigatoriedade()) {
                    return;
                }
                if(this.comunicacaoTransferencia.codDevedor == null) {
                    this.exibirMensagem("Informe um devedor existente ou inclua um novo.");
                    return;
                }
                if (this.verificarValorVazio(this.comunicacaoTransferencia.dataTransferencia)) {
                    this.$refs['dadosComunicacaoTransferencia'].validarDataTransferencia()
                    return
                }

                if(parseInt(this.filtros.cnj.substring(11, 15)) <= 2016) {
                    this.$refs['modal-confirmar-data'].show();
                } else {
                    this.confirmarSalvar();
                }
            },
            async confirmarSalvar() {
                this.$refs['modal-confirmar-data'].hide();
                this.$refs['modal-avancar-ef'].hide();
                this.$refs['modal-confirmar-dupla'].hide();

                let comunicacaoTransferenciaSalvar = {
                    codComunicacaoTransferencia: this.comunicacaoTransferencia.codComunicacaoTransferencia,
                    codDevedor: this.comunicacaoTransferencia.codDevedor,
                    cpfCnpjDevedor: this.comunicacaoTransferencia.cpfCnpjDevedor,
                    nomeDevedor: this.comunicacaoTransferencia.nomeDevedor,
                    codSetor: this.comunicacaoTransferencia.codSetor,
                    valor: this.tratarCamposNumericos(this.comunicacaoTransferencia.valor),
                    dataTransferencia: this.comunicacaoTransferencia.dataTransferencia,
                    cnj: this.filtros.cnj,
                    observacoes: this.comunicacaoTransferencia.observacoes,
                    arquivos: this.comunicacaoTransferencia.arquivos,
                    titularReceita: this.comunicacaoTransferencia.titularReceita,
                    enviarDocumentacao: this.comunicacaoTransferencia.enviarDocumentacao,
                    email: this.comunicacaoTransferencia.email
                };

                this.load = true;
                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/comunicacaoTransferencia/salvar`, comunicacaoTransferenciaSalvar, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.codigoReceita = response.data;
                    this.$refs.wizard.nextTab();
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.load = false;
                    this.$refs.loading.hideLoading();
                });
            },
            verificarObrigatoriedade() {
                this.validations.cpfCnpjDevedor.valid = true;
                this.validations.nomeDevedor.valid = true;
                this.validations.valor.valid = true;
                this.validations.setor.valid = true;
                this.validations.data.valid = true;
                this.validations.data.pastDate = true;
                this.validations.observacoes.valid = true;

                let valid = true;
                if(this.verificarValorVazio(this.comunicacaoTransferencia.cpfCnpjDevedor)) {
                    this.validations.cpfCnpjDevedor.valid = false;
                    valid = false;
                }
                if(this.verificarValorVazio(this.comunicacaoTransferencia.nomeDevedor)) {
                    this.validations.nomeDevedor.valid = false;
                    valid = false;
                }
                if(this.verificarValorVazio(this.comunicacaoTransferencia.valor)) {
                    this.validations.valor.valid = false;
                    this.validations.valor.mensagem = "O campo Valor Transferido (R$) é obrigatório.";
                    valid = false;
                }
                if(this.verificarValorVazio(this.comunicacaoTransferencia.codSetor)) {
                    this.validations.setor.valid = false;
                    valid = false;
                }
                if(this.verificarValorVazio(this.comunicacaoTransferencia.dataTransferencia)) {
                    this.validations.data.valid = false;
                    valid = false;
                } else if(new Date(this.comunicacaoTransferencia.dataTransferencia) > new Date()) {
                    this.validations.data.pastDate = false;
                    valid = false;
                }
                if(this.comunicacaoTransferencia.titularReceita == 1 && this.verificarValorVazio(this.comunicacaoTransferencia.observacoes)) {
                    this.validations.observacoes.valid = false;
                    valid = false;
                }

                return valid;
            },
            async obterComunicacaoTransferencia(id, avancarDois) {
                this.$refs.loading.showLoading()
                await axios.get(`${this.urlApi}/v1/comunicacaoTransferencia/obter/` + id, {
                    headers: {
                        'Authorization': this.token,
                        'Content-Type': 'application/json',
                    }
                }).then(response => {
                    this.comunicacaoTransferencia = response.data

                    this.filtros.cnj = this.comunicacaoTransferencia.cnj;

                    let valor = null
                    if (this.comunicacaoTransferencia.valor != null) {
                        valor = this.comunicacaoTransferencia.valor.toString()
                        if (valor.split(".").length <= 1) {
                            valor += "00"
                        } else if (valor.split(".")[1].length == 1) {
                            valor += "0"
                        }
                    }
                    this.comunicacaoTransferencia.valor = this.formatarMonetario(valor);
                    this.$refs.wizard.nextTab();

                    if(avancarDois) {
                        this.$refs.wizard.nextTab();
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading()
                })
            },
            alterarValidadeValor(valido) {
                this.validations.valor.valid = valido;
                this.validations.valor.mensagem = "Não é permitida a emissão de Requisição de valor zero ou negativo.";
            },
            acionarEnter(e) {
                if(this.$refs.wizard.activeTabIndex == 0 && e.key == 'Enter') {
                    this.avancaPrimeiraAba();
                } else if(this.$refs.wizard.activeTabIndex == 1 && e.key == 'Enter') {
                    document.getElementById("btnProximaTabela").click();
                }
            },
            enterCnj() {
                document.getElementById("btnProxima").click();
            },
            sair() {
                this.$router.push({path: '/honorarios'});
            },
            focusCnj() {
                document.getElementsByClassName('cnj')[0].focus();
            },
            acionarEnterDelay(e) {
                if(e.key == 'Enter' && (e.path == undefined || e.path[0].type == undefined || e.path[0].type != 'button')) {
                    setTimeout(()=>{
                        this.acionarEnter(e);
                    }, 200);
                }
            },
            async obterEmailCesTransf() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/obterEmailCesTransf`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.emailCes = response.data;
                })
            },
            alterarTitularReceita(titularReceita) {
                this.filtros.titularReceita = titularReceita;
                this.comunicacaoTransferencia.titularReceita = titularReceita;
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            let comunicacaoTransferencia = this.$store.getters.getComunicacaoTransferencia
            if (comunicacaoTransferencia) {
                this.$store.commit('setComunicacaoTransferencia', null)
                this.obterComunicacaoTransferencia(comunicacaoTransferencia, true)
            }

            this.obterEmailCesTransf();

            setTimeout(()=>{
                this.focusCnj();
                window.addEventListener("keypress", this.acionarEnterDelay);
            }, 500);
        },
    }
</script>

<style>
    .stepTitle {
        display: none;
    }

    .stepTitle.active {
        display: block !important;
    }
</style>
